/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */


import { IAction } from 'src/js/actions/IshAction';
import { AdobeAnalyticsEvent } from 'src/js/model/checkout/AdobeAnalytics';

export const SEND_ADOBE_ANALYTICS_EVENT = 'SEND_ADOBE_ANALYTICS_EVENT'

export const sendAdobeAnalyticsEvent = (type: AdobeAnalyticsEvent, event?: Record<any, any>): IAction => ({
  type: SEND_ADOBE_ANALYTICS_EVENT,
  payload: { type, event }
})